import { SDS_BRAND_COLOR_BORDER_WEAK_NEUTRAL } from '@s-group/design-system-tokens/web/tokens/s-pankki/colors.es6'
import { SPACE_LARGE_PLUS, SPACE_SMALL } from '@ui-components/global/spacing'
import { Fragment, PropsWithChildren } from 'react'
import { styled } from 'styled-components'

import { LooseFormSectionContent } from '../containers/LooseSectionContent'
import { Divider } from '../decorative/Divider'
import { BREAKPOINT_LARGE_DESKTOP_PX } from '../global/constants'
import { LEGACY_SPACE_XLARGE } from '../global/legacy/spacing'
import { SecondaryHeading } from '../typography/headings/SecondaryHeading'

const PhaseSummaryContainer = styled(LooseFormSectionContent)`
  padding: ${SPACE_LARGE_PLUS} ${SPACE_SMALL} ${LEGACY_SPACE_XLARGE} ${SPACE_SMALL};
  border: 1px solid ${SDS_BRAND_COLOR_BORDER_WEAK_NEUTRAL};
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINT_LARGE_DESKTOP_PX}px) {
    padding: ${SPACE_LARGE_PLUS} ${SPACE_LARGE_PLUS} ${LEGACY_SPACE_XLARGE};
  }
`

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE_SMALL};
`

export interface PhaseSummaryProps {
  heading: string
  headerCaption?: string
}

export const PhaseSummary = ({ heading, children, headerCaption }: PropsWithChildren<PhaseSummaryProps>) => {
  const stepSummaries = Array.isArray(children) ? children.filter(Boolean) : children ? [children] : undefined
  const shouldUseStepContainer = stepSummaries && stepSummaries.length > 1

  return (
    <PhaseSummaryContainer>
      <SecondaryHeading header={heading} headerCaption={headerCaption} />
      {shouldUseStepContainer
        ? stepSummaries.map((stepSummary, index) => {
            return (
              <Fragment key={stepSummary?.key}>
                {index !== 0 && <Divider data-testid="divider" />}
                <StepContainer key={stepSummary?.key}>{stepSummary}</StepContainer>
              </Fragment>
            )
          })
        : children}
    </PhaseSummaryContainer>
  )
}
